module.exports = {
  apiRoot: navigator.userAgent !== "ReactSnap" ? "" : "http://localhost:4000",
};
